import { render } from "./filaSeccion.vue?vue&type=template&id=1bc45cd6"
import script from "./filaSeccion.vue?vue&type=script&lang=js"
export * from "./filaSeccion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\wwwlu\\OneDrive\\Desktop\\Proyectos\\web\\2024\\electo\\electopedia_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
